module.exports = __webpack_public_path__ + "static/media/news_04.872bacf6.jpg";